module.exports = __webpack_public_path__ + "static/awards_2-6af838bda142c55308ba98ec61c5b10f.png";